import type { FaireProductEntity } from "../../entity_types/product";

export const p_4uchs5d2z4: FaireProductEntity = {
  token: "p_4uchs5d2z4",
  type: "product",
  name: "Organic California Poppy Loose Leaf Tea",
  brandToken: "b_bqcgv7uqrr",
  brandName: "Healing Herbals",
  imageUrl:
    "https://cdn.faire.com/fastly/3d7d9cdc3c53c095a6a3b1ada57c00ac2241a4674f1bc2c96d574499d0f3f392.jpeg",
  galleryImageUrls: [],
  priceDollars: 31.03,
  description:
    "\nOrganic California Poppy Loose Leaf Tea\n\nExperience the soothing embrace of Organic California Poppy Loose Leaf Tea from Healing Herbals. Harvested from the rich soils of California, this organic tea is derived from the California Poppy (Eschscholzia californica), known for its mild sedative properties and ability to promote relaxation and support sleep. Our California Poppy Tea is the perfect herbal brew for those looking to naturally ease into a state of calm and enhance their nighttime routine.\n\nProduct Highlights:\n\n * Ingredients: 100% organic California Poppy leaves and flowers \n * Benefits: Aids relaxation, supports quality sleep, and contributes to overall calmness \nBrewing Instructions: Steep one teaspoon of loose leaf tea in boiling water for 5-10 minutes.",
  tags: [],
  msrpDollars: 38.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:46.040Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
